export default {"src":"/_next/static/media/laboratory-upload-version.f9d82373.svg","height":170,"width":170,"blurWidth":0,"blurHeight":0};